import React, { Component } from 'react';
import { connect } from 'react-redux';
import { HashLink as Link } from 'react-router-hash-link';
import get from 'lodash/get';
import uniqueId from 'lodash/uniqueId';
import Lottie from 'react-lottie';
import animationData from '../../assets/lottie/alert-attention.json';

import {
  checkStatus,
  fetchAccountLocalRestrictions,
  fetchAccountRestrictions,
} from '../../actions';
import { addAlert, ALERT_TYPE, dismissAlert } from '../../actions/alerts';
import imgRestriction from '../../assets/images/warning.svg';
import imgDriverLicense from '../../assets/images/alertDriverLicense.svg';
import './index.css';

export const getAlertByType = (type, accountNumber) => {
  let alert = null;
  switch (type) {
    case ALERT_TYPE.ACCOUNT_RESTRICTED:
      alert = (
        <div styleName="alertBody">
          <div styleName="alertRow" key={uniqueId()}>
            <img src={imgRestriction} alt="Warning" styleName="alertImg" />
            <div styleName="alertMessage">
              Your account is currently restricted. Please go to the&nbsp;
              <Link styleName="alertLink" to={`/account/${accountNumber}`}>
                Manage Account
              </Link>
              &nbsp;page to resolve the restriction.&nbsp;
            </div>
          </div>
          <div styleName="alertRowDivider" />
        </div>
      );
      break;
    case ALERT_TYPE.DL_NOT_UPLOADED:
      alert = (
        <div styleName="alertBody">
          <div styleName="alertRow" key={uniqueId()}>
            <div styleName="alertImage">
              <img src={imgDriverLicense} alt="Warning" styleName="alertImg" />
            </div>
            <div styleName="alertContent">
              <div styleName="alertMessage">
                Please&nbsp;
                <Link styleName="alertLink" to={`/user/${accountNumber}/upload-dl`}>
                  upload your driver license
                </Link>
                &nbsp;to verify your identity.
              </div>
            </div>
          </div>
          <div styleName="alertRowDivider" />
        </div>
      );
      break;
    // Provisionally comment out w. Joel's request
    // case ALERT_TYPE.BANK_LINK_NOT_ADDED:
    //   alert = (
    //     <div styleName="alertBody">
    //       <div styleName="alertRow" key={uniqueId()}>
    //         <div styleName="alertImage">
    //           <img src={imgBank} alt="Warning" styleName="alertImg" />
    //         </div>
    //         <div styleName="alertContent">
    //           <div styleName="alertMessage">
    //             Please&nbsp;
    //             <Link styleName="alertLink" to={`/account/${accountNumber}/#bank-link-info`}>
    //               link your bank account
    //             </Link>
    //             &nbsp;and then start investing.
    //           </div>
    //         </div>
    //       </div>
    //       <div styleName="alertRowDivider" />
    //     </div>
    //   );
    //   break;
    // no default
  }
  return alert;
};

export class AlertAttention extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlerts: false,
      alertAnimationStopped: false,
      alertAnimationPaused: false,
    };
  }
  async componentDidMount() {
    await this.props.fetchAccountRestrictions(this.props.currentAccount);
    await this.props.fetchAccountLocalRestrictions(this.props.currentAccount);
    // add bank link alert
    // Provisionally comment out w. Joel's request
    // const { bankLinks } = filterActiveBankLinks(this.props.accountBankLinks);
    // if (bankLinks.length === 0) {
    //   const visibleBankAccountAlert = this.props.alerts.filter(alert => alert.visible && alert.type === ALERT_TYPE.BANK_LINK_NOT_ADDED);
    //   if (visibleBankAccountAlert.length === 0) {
    //     this.props.addAlert(ALERT_TYPE.BANK_LINK_NOT_ADDED);
    //   }
    // }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentAccount !== nextProps.currentAccount
      && nextProps.currentAccount.length > 0) {
      this.props.fetchAccountRestrictions(nextProps.currentAccount);
      this.props.fetchAccountLocalRestrictions(nextProps.currentAccount);
    }

    if (this.props.restrictions.length !== nextProps.restrictions.length
      && nextProps.restrictions.length > 0) {
      this.props.addAlert(ALERT_TYPE.ACCOUNT_RESTRICTED);
    }

    if (this.props.localRestrictions.length !== nextProps.localRestrictions.length) {
      if (nextProps.localRestrictions.length > 0) {
        this.props.addAlert(ALERT_TYPE.DL_NOT_UPLOADED);
      } else {
        this.props.alerts.forEach((alert) => {
          if (alert.type === ALERT_TYPE.DL_NOT_UPLOADED && alert.visible) {
            this.props.dismissAlert(alert.id);
          }
        });
      }
    }
    // Provisionally comment out w. Joel's request
    // if (!isEqual(this.props.accountBankLinks, nextProps.accountBankLinks)) {
    //   const currentBankLink = filterActiveBankLinks(this.props.accountBankLinks);
    //   const nextBankLink = filterActiveBankLinks(nextProps.accountBankLinks);
    //   if (currentBankLink.bankLinks.length === 0 && nextBankLink.bankLinks.length === 1) {
    //     this.props.alerts.forEach((alert) => {
    //       if (alert.type === ALERT_TYPE.BANK_LINK_NOT_ADDED && alert.visible) {
    //         this.props.dismissAlert(alert.id);
    //       }
    //     });
    //   }
    // }
  }

  handleAlertListDisplay = () => {
    this.setState({
      showAlerts: !this.state.showAlerts,
      alertAnimationPaused: !this.state.alertAnimationPaused,
    });
  };

  render() {
    const { alerts, currentAccount } = this.props;
    const { showAlerts } = this.state;
    const visibleAlerts = alerts.filter(alert => alert.visible);
    const animationOptions = {
      loop: true,
      autoplay: true,
      animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };
    const alertAttention = (
      <button styleName="alertBtn" onClick={this.handleAlertListDisplay}>
        <Lottie
          options={animationOptions}
          height={56}
          width={56}
          isStopped={this.state.alertAnimationStopped}
          isPaused={this.state.alertAnimationPaused}
        />
      </button>
    );
    const alertContainer = (
      <div styleName="alertContainer">
        {
          visibleAlerts.map(alert => (getAlertByType(alert.type, currentAccount)))
        }
      </div>
    );
    return (
      <div>
        { visibleAlerts.length > 0 ? alertAttention : '' }
        { showAlerts ? alertContainer : null }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  alerts: get(state, 'alerts', []),
  status: get(state, 'serviceStatus.status', 'ok'),
  currentAccount: get(state, 'currentAccount', null),
  restrictions: get(state, 'currentAccount', null) ?
    get(state, `accountRestrictionsByAccount[${get(state, 'currentAccount')}].data`, []) : [],
  localRestrictions: get(state, 'currentAccount', null) ?
    get(state, `accountLocalRestrictionsByAccount[${get(state, 'currentAccount')}].data`, []) : [],
  accountBankLinks: get(state, `accountBankLinks.[${state.currentAccount}].data`, []),
});

const mapDispatchToProps = {
  checkStatus,
  addAlert,
  dismissAlert,
  fetchAccountRestrictions,
  fetchAccountLocalRestrictions,
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertAttention);



// WEBPACK FOOTER //
// ./src/components/AlertAttention/index.js